module.exports = __webpack_public_path__ + "assets/svg/Icons/32/newsfeed-gray-e52b6c.svg";